export default {
  data() {
    return {
      columns: [
        {
          prop: "id",
          label: "ID",
          default: "No ID"
        },
        {
          prop: "floor_id",
          label: "Floor ID",
          default: "No Floor ID"
        },
        {
          prop: "name",
          label: "Name",
          default: "No Name"
        },
        {
          prop: "description",
          label: "Description",
          default: "No Description"
        },
        {
          prop: "action",
          label: "Action",
          isAction: true
        }
      ],
      paginationMeta: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 15
      },
      propsToSearch: ["name"],
      searchQuery: ""
    };
  }
};
